import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./ReportCRUD";
import { reportSlice } from "./ReportSlice";

const { actions } = reportSlice;

export const transactionReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .callTransactionReport(queryParams)
    .then((response) => {
      if (response && response.data) {
        if (!response.data.isAbort) {
          dispatch(actions.transactionReportFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: transactionReportFetched");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
